import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import operations from './operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'pagerTemplates',
  baseType: 'PAGER_TEMPLATES',
  apiEndpoint: 'pagers/templates'
};

const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
